/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { Library } from '../../Library';
import { AbstractCommand } from '../AbstractCommand';
import { ModelUtils } from '../util/ModelUtils';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { Document } from '../../core/models/Document';

/**
 * A command used to modify the license information of a document.
 * @author eric.wittmann@gmail.com
 * @extends AbstractCommand
 * @class
 */
export class ChangeLicenseCommand extends AbstractCommand {
    public _newLicenseName : string;

    public _newLicenseUrl : string;

    public _oldLicense : any;

    public _nullInfo : boolean;

    public constructor(name? : any, url? : any) {
        if(((typeof name === 'string') || name === null) && ((typeof url === 'string') || url === null)) {
            let __args = arguments;
            super();
            if(this._newLicenseName===undefined) this._newLicenseName = null;
            if(this._newLicenseUrl===undefined) this._newLicenseUrl = null;
            if(this._oldLicense===undefined) this._oldLicense = null;
            if(this._nullInfo===undefined) this._nullInfo = false;
            if(this._newLicenseName===undefined) this._newLicenseName = null;
            if(this._newLicenseUrl===undefined) this._newLicenseUrl = null;
            if(this._oldLicense===undefined) this._oldLicense = null;
            if(this._nullInfo===undefined) this._nullInfo = false;
            (() => {
                this._newLicenseName = name;
                this._newLicenseUrl = url;
            })();
        } else if(name === undefined && url === undefined) {
            let __args = arguments;
            super();
            if(this._newLicenseName===undefined) this._newLicenseName = null;
            if(this._newLicenseUrl===undefined) this._newLicenseUrl = null;
            if(this._oldLicense===undefined) this._oldLicense = null;
            if(this._nullInfo===undefined) this._nullInfo = false;
            if(this._newLicenseName===undefined) this._newLicenseName = null;
            if(this._newLicenseUrl===undefined) this._newLicenseUrl = null;
            if(this._oldLicense===undefined) this._oldLicense = null;
            if(this._nullInfo===undefined) this._nullInfo = false;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[ChangeLicenseCommand] Executing.");
        this._oldLicense = null;
        this._nullInfo = false;
        if(this.isNullOrUndefined(document.info)) {
            this._nullInfo = true;
            document.info = document.createInfo();
            this._oldLicense = null;
        } else {
            this._oldLicense = null;
            if(!this.isNullOrUndefined(document.info.license)) {
                this._oldLicense = Library.writeNode(document.info.license);
            }
        }
        document.info.license = document.info.createLicense();
        document.info.license.name = this._newLicenseName;
        document.info.license.url = this._newLicenseUrl;
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[ChangeLicenseCommand] Reverting.");
        if(this._nullInfo) {
            document.info = null;
        } else if(ModelUtils.isDefined(this._oldLicense)) {
            document.info.license = document.info.createLicense();
            Library.readNode(this._oldLicense, document.info.license);
        } else {
            document.info.license = null;
        }
    }
}
ChangeLicenseCommand["__class"] = "io.apicurio.datamodels.cmd.commands.ChangeLicenseCommand";
ChangeLicenseCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




